import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import Lottie from "lottie-react";

import successAnim from "../animations/success.json";
import goodAnim from "../animations/good.json";
import failAnim from "../animations/fail.json";

function MCQLayout({
  title,
  subject,
  teacher,
  questions = [],
  timeLeft,
  onAnswer,
  answers = {},
  onSubmit,
  onContinue,
  onRetry,
  onReview,
  submitted = false,
  historyReviewMode = false,
  showReview = false,
  score = 0,
  showPremium = false,
  showContinue = true
}) {

  const navigate = useNavigate();

  const isReviewMode =
    historyReviewMode || showReview;

  const formatTime = (time) => {

    if (typeof time !== "number")
      return time;

    const m =
      Math.floor(time / 60);

    const s =
      time % 60;

    return `${m
      .toString()
      .padStart(2, "0")} : ${s
      .toString()
      .padStart(2, "0")}`;

  };

  useEffect(() => {

    const style =
      document.createElement("style");

    style.innerHTML = `
      @keyframes popupScale {

        from {

          transform: scale(0.6);

          opacity: 0;

        }

        to {

          transform: scale(1);

          opacity: 1;

        }

      }

      @keyframes confetti {

        0% {

          transform:
            translateY(-100vh)
            rotate(0deg);

        }

        100% {

          transform:
            translateY(100vh)
            rotate(360deg);

        }

      }

      .confetti {

        position: fixed;

        width: 8px;

        height: 8px;

        top: 0;

        animation:
          confetti 2s linear infinite;

        z-index: 9999;

      }
    `;

    document.head.appendChild(style);

  }, []);

  const renderConfetti = () => {

    return Array.from({
      length: 40
    }).map((_, i) => (

      <div
        key={i}
        className="confetti"
        style={{
          left:
            Math.random() *
              100 +
            "%",

          background: [

            "#22c55e",

            "#3b82f6",

            "#f59e0b",

            "#ef4444"

          ][i % 4],

          animationDelay:
            Math.random() *
              2 +
            "s"
        }}
      />

    ));

  };

  return (

    <div style={pageWrapper}>

      <div style={page}>

        {/* LOGO */}

        <div style={logoBox}>

          <img
            src="/logo2.png"
            alt="logo"
            style={logo}
          />

        </div>

        {/* HEADER */}

        <div style={examInfoBox}>

        <div style={infoTop}>

          <div>

            <h2>{title}</h2>

            <p>

              <b>Subject:</b>{" "}
              {subject || "-"}

              <br />

              <b>Teacher:</b>{" "}
              {teacher || "-"}

            </p>

          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}
          >

            {isReviewMode && (

              <button
                style={closeBtn}
                onClick={() =>
                  navigate("/profile")
                }
              >
                ✕ Close
              </button>

            )}

            <div style={timerBox}>

              ⏱ {formatTime(timeLeft)}

            </div>

          </div>

        </div>

      </div>

        {/* QUESTIONS */}

        <div style={examPaper}>

          {questions.map(
            (q, i) => (

              <div
                key={q.id}
                style={{
                  marginBottom: 25
                }}
              >

                <h4>

                  {i + 1}.{" "}
                  {q.question}

                </h4>

                {q.options.map(
                  (
                    opt,
                    idx
                  ) => {

                    const optionKey =

                      [
                        "A",
                        "B",
                        "C",
                        "D"
                      ][idx];

                    const selected =

                      answers[
                        q.id
                      ] ===
                      optionKey;

                    const isCorrect =
                      q.correct_answer ===
                      optionKey;

                    return (

                      <label
                        key={idx}
                        style={{
                          ...option,

                          background:
                            isReviewMode
                              ? isCorrect
                                ? "#dcfce7"
                                : selected && !isCorrect
                                ? "#fee2e2"
                                : "#f8fafc"
                              : selected
                              ? "#dbeafe"
                              : "#f8fafc",

                          border:
                            selected
                              ? "2px solid #2563eb"
                              : "2px solid transparent"
                        }}
                      >

                        <input
                          type="radio"
                          name={`q-${q.id}`}
                          disabled={
                            submitted ||
                            isReviewMode
                          }
                          checked={
                            selected
                          }
                          onChange={() =>
                            onAnswer(
                              q.id,
                              optionKey
                            )
                          }
                        />

                        {opt}
                         {isReviewMode &&
                           isCorrect && (

                             <span
                               style={{
                                 marginLeft: "10px",
                                 color: "green",
                                 fontWeight: "bold"
                               }}
                             >
                               ✓ Correct Answer
                             </span>

                         )}

                         {isReviewMode &&
                           selected &&
                           !isCorrect && (

                             <span
                               style={{
                                 marginLeft: "10px",
                                 color: "red",
                                 fontWeight: "bold"
                               }}
                             >
                               ✗ Your Answer
                             </span>

                         )}




                      </label>

                    );

                  }
                )}

                {isReviewMode && (

                  <div
                    style={{
                      marginTop:
                        "10px",
                      padding:
                        "10px",
                      background:
                        "#f1f5f9",
                      borderRadius:
                        "10px"
                    }}
                  >

                    <b>
                      Explanation:
                    </b>{" "}

                    {q.explanation ||
                      "No explanation available"}

                  </div>

                )}

              </div>

            )
          )}

          {!submitted &&
            !isReviewMode && (

            <div
              style={{
                textAlign:
                  "right"
              }}
            >

              <button
                style={
                  submitBtn
                }
                onClick={
                  onSubmit
                }
              >

                🚀 Submit

              </button>

            </div>

          )}

        </div>

      </div>

      {/* RESULT POPUP */}

      {submitted &&
        !isReviewMode &&
        (() => {

          const total =
            questions.length;

          const percent =

            total > 0
              ? (score /
                  total) *
                100
              : 0;

          let message = "";

          let color =
            "#22c55e";

          let animation =
            successAnim;

          let sound =
            "/sound/success.mp3";

          if (
            percent === 100
          ) {

            message =
              "Perfect! You nailed it!";

          }

          else if (
            percent >= 60
          ) {

            message =
              "Good job! Keep going!";

            animation =
              goodAnim;

            sound =
              "/sound/good.mp3";

          }

          else {

            message =
              "Oops! Try again!";

            color =
              "#ef4444";

            animation =
              failAnim;

            sound =
              "/sound/fail.mp3";

          }

          return (

            <div
              style={
                overlayUltra
              }
            >

              <audio
                key={sound}
                src={sound}
                autoPlay
              />

              {percent ===
                100 &&
                renderConfetti()}

              <div
                style={
                  popupUltra
                }
              >

                <div
                  style={
                    topUltra
                  }
                >

                  <Lottie
                    animationData={
                      animation
                    }
                    style={{
                      height: 140
                    }}
                  />

                </div>

                <h2
                  style={
                    titleUltra
                  }
                >

                  Your Result

                </h2>

                <h1
                  style={{
                    fontSize:
                      "48px",

                    color,

                    margin:
                      "10px 0",

                    fontWeight:
                      "bold"
                  }}
                >

                  {score} /{" "}
                  {total}

                </h1>

                <p
                  style={
                    messageUltra
                  }
                >

                  {message}

                </p>

                {showContinue && (

                  <button
                    style={
                      btnUltra
                    }
                    onClick={
                      onContinue
                    }
                  >

                    Continue →

                  </button>

                )}

                <button
                  type="button"
                  style={{
                    ...btnUltra,
                    marginTop:
                      "10px",
                    background:
                      "linear-gradient(135deg,#3b82f6,#2563eb)"
                  }}
                  onClick={(e) => {

                    e.preventDefault();

                    e.stopPropagation();

                    if (
                      typeof onReview ===
                      "function"
                    ) {

                      onReview();

                    }

                  }}
                >

                  📄 Review Paper

                </button>

                {percent <
                  100 && (

                  <button
                    style={
                      retryBtn
                    }
                    onClick={() => {

                      if (
                        onRetry
                      ) {

                        onRetry();

                      }

                    }}
                  >

                    🔄 Try Again

                  </button>

                )}

              </div>

            </div>

          );

        })()}

      {/* PREMIUM POPUP */}

      {showPremium && (

        <div
          style={
            premiumOverlay
          }
        >

          <div
            style={
              premiumCard
            }
          >

            <h2
              style={{
                fontSize:
                  "34px",

                marginBottom:
                  "15px",

                fontWeight:
                  "bold"
              }}
            >

              🔒 Premium MCQ

            </h2>

            <p
              style={{
                lineHeight:
                  "1.8",

                color:
                  "#555",

                marginBottom:
                  "25px"
              }}
            >

              More MCQ attempts
              require payment
              access.

            </p>

            <button
              style={
                premiumBtn
              }
              onClick={() => {

                const user = JSON.parse(
                  localStorage.getItem("user") || "null"
                );

                // Guest user
                if (!user?.id) {

                  localStorage.setItem(
                    "redirect_after_login",
                    "/profile"
                  );

                  navigate("/auth");
                  return;
                }

                // Already logged user
                navigate("/profile");

              }}
            >

              🔓 Unlock Now

            </button>

          </div>

        </div>

      )}

    </div>

  );

}

export default MCQLayout;

/* ================= STYLES ================= */

const pageWrapper = {
  minHeight: "100vh",
  background:"linear-gradient(135deg,#0f172a,#020617)",
  display: "flex",
  justifyContent:"center",
  padding: "40px 15px"
};

const page = {
  width: "100%",
  maxWidth: "900px"
};

const logoBox = {
  textAlign: "center",
  marginBottom: "15px"
};

const logo = {width: "90px"};

const examInfoBox = {
  background: "#fff",
  padding: "25px",
  borderRadius: "18px",
  marginBottom: "25px"

};

const infoTop = {
  display: "flex",
  justifyContent:"space-between"
};

const timerBox = {
  border:"2px solid #000",
  padding: "8px 14px",
  borderRadius: "8px"

};

const examPaper = {
  background: "#fff",
  padding: "35px",
  borderRadius: "20px"

};

const option = {
  display: "block",
  margin: "8px 0",
  padding: "10px",
  borderRadius: "10px"
};

const submitBtn = {
  padding: "14px 35px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: "12px",
  cursor: "pointer"
};

const overlayUltra = {
  position: "fixed",
  inset: 0,
  background:"rgba(0,0,0,0.85)",
  backdropFilter:"blur(12px)",
  display: "flex",
  justifyContent:"center",
  alignItems: "center",
  zIndex: 9999
};

const popupUltra = {
  width: "380px",
  padding:"80px 30px 30px",
  borderRadius: "30px",
  textAlign: "center",
  background:"linear-gradient(135deg,#1e293b,#020617)",
  color: "#fff",
  position: "relative",
  animation:"popupScale 0.35s ease"
};

const topUltra = {position: "absolute",top: "-60px",left: "50%",transform:"translateX(-50%)"};
const titleUltra = {marginTop: "20px"};
const messageUltra = { marginBottom: "20px"};

const btnUltra = {
  width: "100%",
  padding: "14px",
  borderRadius: "16px",
  border: "none",
  background:"linear-gradient(135deg,#22c55e,#16a34a)",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"
};

const retryBtn = {
  width: "100%",
  padding: "14px",
  borderRadius: "16px",
  border: "none",
  background:"linear-gradient(135deg,#ef4444,#dc2626)",
  color: "#fff",
  fontWeight: "bold",
  marginTop: "10px",
  cursor: "pointer"

};

const premiumOverlay = {
  position: "fixed",
  inset: 0,
  background:"rgba(0,0,0,0.8)",
  backdropFilter:"blur(10px)",
  display: "flex",
  justifyContent:"center",
  alignItems: "center",
  zIndex: 10000

};

const premiumCard = {
  width: "380px",
  background: "#fff",
  padding: "35px",
  borderRadius: "24px",
  textAlign: "center",
  border:"2px dashed #ef4444"
};

const premiumBtn = {
  width: "100%",
  padding: "15px",
  border: "none",
  borderRadius: "14px",
  background:"linear-gradient(135deg,#ef4444,#dc2626)",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"

};

const closeBtn = {
  background: "#ef4444",
  color: "#fff",
  border: "none",
  padding: "10px 16px",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer"

};